import type { FC } from 'react';
import { Table, TableHead, TableBody, TableRow, Card, Box } from '@material-ui/core';
import Title from '../../../components/admin/Title';
import Scrollbar from '../../../components/admin/Scrollbar';
import TableCellHeaderSum from '../../../components/global/TableCellHeaderSum';
import SeguimientoTerritorioDetailRow from './SeguimientoTerritorioDetailRow';

const SeguimientoTerritorioDetail: FC<{ content: any[]; total: number }> = ({
  content,
  total,
}) => {
  const title = 'Facturación de Convenios por Territorio, En MM PEN';
  return (
    <Box pt={2}>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCellHeaderSum>Territorio</TableCellHeaderSum>
                <TableCellHeaderSum align="right" width={100}>
                  Total
                </TableCellHeaderSum>
              </TableRow>
            </TableHead>
            <TableBody>
              {content.map((item) => (
                <SeguimientoTerritorioDetailRow item={item} />
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCellHeaderSum>Total</TableCellHeaderSum>
                <TableCellHeaderSum align="right" width={100}>
                  {total}
                </TableCellHeaderSum>
              </TableRow>
            </TableHead>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default SeguimientoTerritorioDetail;
